import React, { useContext } from "react";
import { MultiSelect, Select, Skeleton } from "@mantine/core";
import {
  EButton,
  EInfoPanel,
  EPageTitle,
  EVerticalFormSection,
} from "../../libs/ui";
import { CSVLink } from "react-csv";
import moment from "moment";
import useStudentWisePeriodicAssessment from "./hook/useStudentWisePeriodicAssessment";
import { ROLES } from "../../Routes/routes";
import { AppContext } from "../../AppContext";
import PageLayout from "../../PageLayout";

const StudentWisePeriodicAssessment = () => {
  const { user, role } = useContext(AppContext);
  const {
    selectedDistrict,
    setSelectedDistrict,
    selectedBlock,
    setSelectedBlock,
    selectedSession,
    setSelectedSession,
    districts,
    blocks,
    sessions,
    studentwisePeriodicData,
    isLoading,
    handleApplyFilter,
    grade,
    setGrade,
    subject,
    setSubject,
    subjectList,
    classes,
    assessmentTypes,
    setAssessmentId,
    assessmentId,
    downloadExcel,
  } = useStudentWisePeriodicAssessment();
  return (
    <PageLayout>
      {/* Header */}
      <EPageTitle title={"Student Wise Periodic Assessment"} description="" />
      <div>
        {/* Filters */}
        <div className="filter-container mt-4">
          <div className="flex gap-3 items-end flex-wrap">
            <Select
              label="Select Session"
              className="w-1/4"
              labelProps={{ className: "font-semibold" }}
              placeholder="Select Session"
              data={[
                ...sessions
                  //   ?.filter((e) => e?.session_Id === 4)
                  ?.map((e) => {
                    return {
                      value: String(e?.session_Id),
                      label: e?.session_Name,
                    };
                  }),
              ]}
              value={selectedSession}
              onChange={(e) => setSelectedSession(String(e))}
            />
            <Select
              label="District"
              className="w-1/4"
              labelProps={{ className: "font-semibold" }}
              placeholder="All Districts"
              clearable
              disabled={
                role?.includes(ROLES.BLOCK) || role?.includes(ROLES.DISTRICT)
                  ? true
                  : false
              }
              data={
                districts?.map((each: any) => ({
                  label: each.name,
                  value: String(each.id),
                })) ?? []
              }
              value={selectedDistrict ?? null}
              onChange={(e: any) => {
                setSelectedBlock(undefined);
                setSelectedDistrict(e);
              }}
            />

            <Select
              label="Block"
              className="w-1/4"
              labelProps={{ className: "font-semibold" }}
              placeholder="All Blocks"
              clearable
              disabled={
                !selectedDistrict || role?.includes(ROLES.BLOCK) ? true : false
              }
              data={
                blocks?.map((each: any) => ({
                  label: each.name,
                  value: String(each.id),
                })) ?? []
              }
              value={selectedBlock ?? null}
              onChange={(e: any) => setSelectedBlock(e)}
            />
            <Select
              searchable={assessmentTypes?.length ? true : false}
              labelProps={{ className: "font-semibold" }}
              required
              placeholder="Select"
              label="Select Assessment"
              data={assessmentTypes?.map((each) => ({
                value: String(each.id),
                label: each.name,
              }))}
              value={assessmentId ? String(assessmentId) : undefined}
              onChange={(e) => {
                setAssessmentId(Number(e));
              }}
            />

            <Select
              labelProps={{ className: "font-semibold" }}
              label="Grade"
              className="w-1/4"
              required
              placeholder="Select"
              // disabled={ false}
              value={grade ? String(grade) : null}
              data={classes?.map((e) => {
                return {
                  value: String(e?.id),
                  label: e?.name,
                };
              })}
              onChange={(e) => {
                setSubject(undefined);
                setGrade(e ? Number(e) : null);
              }}
            />

            <Select
              label="Subject"
              labelProps={{ className: "font-semibold" }}
              required
              placeholder="Select"
              className="w-1/4"
              value={subject ? String(subject) : null}
              data={subjectList?.map((e) => {
                return {
                  value: String(e?.id),
                  label: e?.name,
                };
              })}
              disabled={!grade || grade == 15 ? true : false}
              onChange={(e) => {
                setSubject(e ? e : null);
              }}
            />

            <div className="flex gap-3">
              <EButton
                loading={isLoading}
                disabled={
                  !selectedSession || !grade || !subject || !assessmentId
                }
                className="btn-blue"
                onClick={handleApplyFilter}
              >
                Search
              </EButton>
            </div>
          </div>
        </div>

        {/* DATA */}
        <div className="mt-5">
          {isLoading ? (
            <Skeleton radius={"md"} height={250} />
          ) : studentwisePeriodicData.length ? (
            <EVerticalFormSection
              title="Student Wise Periodic Assessment Report"
              rightPanel={<> </>}
            >
              <div>
                <EInfoPanel title=" Your report is ready to download, Please click on Download File to download report">
                  <EButton className="btn-blue" onClick={downloadExcel}>
                    Download File
                  </EButton>
                </EInfoPanel>
              </div>
            </EVerticalFormSection>
          ) : (
            <EInfoPanel title="Please select filters and press search to generate report" />
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default StudentWisePeriodicAssessment;
